import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {LayoutMgrService} from '../../services/layout-mgr/layout-mgr.service';
import {SystemService} from '../../services/system/system.service';
import {ScrollDownService} from "../../services/scroll-down/scroll-down.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {BackBtnService} from "../../services/back-btn/back-btn.service";

export enum FOOTER_ON {
  NONE,
  MOVIE_COLLECT,
  HOME,
  BOOKMARK,
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @ViewChild('footer') footer: ElementRef;
  @ViewChild('btnScrollDown', { static: true }) btnScrollDown: ElementRef;
  @Input() on = FOOTER_ON.NONE;
  // @Output() bookmark: EventEmitter<boolean>;

  @Input() set disableScrollDown(value: boolean) {
     this._disableScrollDown = value;
  }

  public readonly FOOTER_ON = FOOTER_ON;

  public get height(): number {
    return this.footer.nativeElement.clientHeight;
  }

  // 현재 스크롤 다운 되고있는지 여부
  public isScrollingDown = false;

  // 스크롤 다운 비활성화여부
  private _disableScrollDown = false;

  public get FooterOn(): FOOTER_ON {
    return this.isScrollingDown ? FOOTER_ON.NONE : this.on;
  }


  constructor(
    public systemSvc: SystemService,
    public scrollDownSvc: ScrollDownService,
    private globalEventSvc: GlobalEventService,
    private backBtnSvc: BackBtnService,
    public lm: LayoutMgrService,
  ) {
    // this.bookmark = new EventEmitter<boolean>();

    this.scrollDownSvc.Stop();
  }

  ngOnInit(): void {

    const eScrollDown = this.btnScrollDown.nativeElement;

    eScrollDown?.addEventListener('touchstart',
      this.onStartScrollDown.bind(this),
      { passive: false });  // passive 옵션을 false로 설정하여 preventDefault 호출 가능하게 함

    if (!eScrollDown) {
      console.error('FooterComponent::ngOnInit() eScrollDown is null');
    }
  }


  onStartScrollDown($event: MouseEvent | TouchEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    if (!this._disableScrollDown) {
      this.scrollDownSvc.Start();

      this.isScrollingDown = true;
    }
  }


  onEndScrollDown($event: MouseEvent | TouchEvent): void {
    if ($event.cancelable) {
      $event.preventDefault();
    }
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.scrollDownSvc.Stop();

    this.isScrollingDown = false;
  }

  public getClassScrollDown(): string {
    if (this._disableScrollDown) {
      return 'disable';
    }
    else if (this.isScrollingDown) {
      return 'on';
    }
    else {
      return '';
    }
  }

  onBackBtn($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.backBtnSvc.ProcessBack();
  }
}
